import React, { useCallback, useEffect, useState } from 'react';
import { Container, SimulatorViewer } from './styles';
import IActivityProps from '../../../../dtos/IActivitiesProps';
import { ResourceType } from '../../../../utils/enums';
import IStepProps from '../../../../dtos/IStepsProps';

interface IComponentProps {
  currentActivity: IActivityProps;
  currentStep: IStepProps;
}

const EmbeddingComponent: React.FC<IComponentProps> = ({
  currentStep: step,
}) => {
  const [EmbeddingURL, setEmbeddingURL] = useState(' ');

  const loadTutorialLink = useCallback(async (currentStep: IStepProps) => {
    if (currentStep && currentStep.resourse_type === ResourceType.EMBEDING) {
      if (currentStep) setEmbeddingURL(currentStep.resource_url);
    }
  }, []);

  useEffect(() => {
    if (step) loadTutorialLink(step);
  }, [loadTutorialLink, step]);

  return (
    <Container>
      {step && <SimulatorViewer title="tedt" src={`${EmbeddingURL}`} />}
    </Container>
  );
};

export default EmbeddingComponent;
